import { KYCStatus } from 'services/types/kycStatus';

const AUTO_OPEN_DISMISSED_PREFIX = 'kyc-dialog-auto-dismissed:';

export const getIdentityVerificationAutoOpenDismissedKey = (loginKey: string | null) => {
  return loginKey ? `${AUTO_OPEN_DISMISSED_PREFIX}${loginKey}` : null;
};

export const readIdentityVerificationAutoOpenDismissed = (key: string | null) => {
  if (!key || typeof window === 'undefined') return false;

  try {
    return sessionStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

export const writeIdentityVerificationAutoOpenDismissed = (key: string | null) => {
  if (!key || typeof window === 'undefined') return;

  try {
    sessionStorage.setItem(key, 'true');
  } catch {
    // Ignore storage errors to avoid blocking dialog behavior.
  }
};

export const clearIdentityVerificationAutoOpenDismissed = (key: string | null) => {
  if (!key || typeof window === 'undefined') return;

  try {
    sessionStorage.removeItem(key);
  } catch {
    // Ignore storage errors to avoid blocking dialog behavior.
  }
};

export const getIdentityVerificationStatusKey = (
  status?: KYCStatus | string,
  secondsLeft?: number | null,
  fallbackStatus?: string
) => {
  return `${status || fallbackStatus || ''}-${secondsLeft ?? ''}`;
};
